<template>
  <div class="memberlistitem">
    <div class="pic" v-if="memberlistitem.pics.length > 0">
      <!-- 头像 -->
      <img
        :src="memberlistitem.pics[0].url"
        alt=""
        style="width: 100%; height: 100%; object-fit: cover"
      />
    </div>
    <div class="describe">
      <div class="describe_name">{{ memberlistitem.title }}</div>
      <div class="describe_duty">{{ memberlistitem.desc }}</div>
      <div class="describe_button">
        <div class="describe_but_tel">
          <el-popover
            placement="bottom"
            width="100"
            trigger="click"
            :content="memberlistitem.extra_data[0].value"
          >
            <p slot="reference">电话</p>
          </el-popover>
        </div>
        <div class="describe_but_weixin">
          <el-popover placement="bottom" trigger="click">
            <div class="wx_code_area_for_memberlistitem">
              <img
                :src="memberlistitem.extra_data[1].value[0].url"
                alt=""
                v-if="memberlistitem.extra_data[1].value.length > 0"
              />
              <img v-else src="#" alt="" />
            </div>
            <p slot="reference">微信</p>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MemberListItem",
  mounted() {
    // console.log("memberlistitemmemberlistitem", this.memberlistitem);
  },
  props: {
    memberlistitem: {
      //左上角显示   "最新" 、"推荐"、""
      default: [],
    },
  },
};
</script>
<style lang="scss">
.wx_code_area_for_memberlistitem {
  text-align: center;
  img {
    width: 100px;
    height: 100px ;
    overflow: hidden;
    object-fit: cover;
  }
}
</style>
<style scoped lang="scss">
.memberlistitem {
  position: relative;
  height: 242px;
  width: 165px;
}
.pic {
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 104px;
  height: 103px;
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
  border-radius: 52px;
  background: pink;
  z-index: 5;
}
.describe {
  position: absolute;
  bottom: 0;
  height: 185px;
  width: 165px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: url("~@/assets/images/listitem/bag-eae秘书处@2x.png") no-repeat
    center center;
  background-size: 100% 100%;
  z-index: 4;
  .describe_name {
    height: 29px;
    font-size: 25px;
    font-weight: 500;
    color: #000000;
    line-height: 29px;
    margin-top: 58px;
  }
  .describe_duty {
    height: 17px;
    font-size: 13px;
    
    font-weight: 400;
    color: #444444;
    line-height: 17px;
    margin-top: 14px;
  }
  .describe_button {
    width: 116px;
    font-size: 13px;
    
    font-weight: 400;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 15px;
    .describe_but_tel {
      width: 44px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      background: #0091ff;
      border-radius: 10px;
      border: 2px solid #ffffff;
      &:hover {
        cursor: pointer;
        font-weight: bold;
        opacity: 0.86;
      }
    }
    .describe_but_weixin {
      width: 44px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      background: #529906;
      border-radius: 10px;
      border: 2px solid #ffffff;
      &:hover {
        cursor: pointer;
        font-weight: bold;
        opacity: 0.86;
      }
    }
    
  }
}
</style>


// WEBPACK FOOTER //
// MemberListItem.vue?0518465b